// Toast hook for imperative toasts
let toastId = 0;
let toastContainer: HTMLDivElement | null = null;

function getToastContainer() {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'fixed top-4 right-4 z-50 space-y-2';
    document.body.appendChild(toastContainer);
  }
  return toastContainer;
}

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
  variant?: "default" | "destructive";
}

export function toast(options: ToastOptions) {
  const id = toastId++;
  const element = document.createElement('div');
  element.setAttribute('data-toast-id', id.toString());

  const handleClose = () => {
    element.style.transform = 'translateX(100%)';
    element.style.opacity = '0';
    setTimeout(() => element.remove(), 300);
  };

  // Render toast HTML directly
  const variantClass = options.variant === 'destructive'
    ? 'bg-destructive text-destructive-foreground'
    : 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700';

  element.innerHTML = `
    <div class="pointer-events-auto w-full max-w-sm rounded-lg p-4 shadow-lg transition-all animate-in slide-in-from-right-full ${variantClass}">
      <div class="flex items-start gap-3">
        <div class="flex-1">
          ${options.title ? `<div class="font-medium text-sm">${options.title}</div>` : ''}
          ${options.description ? `<div class="text-sm mt-1 ${options.variant === 'destructive' ? 'opacity-90' : 'text-gray-600 dark:text-gray-400'}">${options.description}</div>` : ''}
        </div>
        <button class="opacity-70 hover:opacity-100 transition-opacity" onclick="this.closest('[data-toast-id]').remove()">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>
  `;

  getToastContainer().appendChild(element);

  const duration = options.duration || 3000;
  if (duration > 0) {
    setTimeout(handleClose, duration);
  }

  return id;
}

// Toaster component (renders toast container)
export function Toaster() {
  return null; // Container is already created imperatively
}
